import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "loading3D-cotainer" }
const _hoisted_2 = { class: "loading-inner-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "loading-content" }
const _hoisted_5 = { class: "inner-content" }
const _hoisted_6 = { class: "title-desc-container" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "desc" }
const _hoisted_9 = {
  key: 0,
  class: "shortcut-key-container"
}
const _hoisted_10 = { class: "item-box" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "key-value" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "key-value" }
const _hoisted_15 = { class: "item-box" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "key-value" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { class: "key-value" }
const _hoisted_20 = {
  key: 0,
  class: "item-box"
}
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { class: "key-value" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = { class: "key-value" }
const _hoisted_25 = { class: "loading-bar-container" }
const _hoisted_26 = { class: "text-container" }
const _hoisted_27 = { class: "load-text" }
const _hoisted_28 = { class: "speed-text" }
const _hoisted_29 = { class: "text-container" }
const _hoisted_30 = { class: "progress-container" }

import {onBeforeMount, ref, watch } from 'vue'
import {saveUserTrainingSetting } from '@/service'
import {$enum} from '@/global/index'
import keyboardConverter from '@/utils/keyboardConverter'
import {useStore} from 'vuex'
import {NProgress} from 'naive-ui'



export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title:{
        type: String,
        default: ''
    },
    description:{
        type: String,
        default: ''
    },
    pageType:{
        //训练，通关，考核
        type: String,
        default: ''
    },
    sceneType:{
        // 场景类型
        type: [String,Number],
        default: ''
    },
    sceneImage:{
        // 场景图片
        type: String,
        default: ''
    },
    engineInitialized: {
        type: Boolean,
        default: false,
    },
    receive: {
        type: [Number,String],
        default: 0,
    },
    sum: {
        type: [Number,String],
        default: 0,
    },
    speed: {
        type: [Number,String],
        default: 0,
    },
  currentFile: {
    type: [Number, String],
    default: 0,
  },
  maxFile: {
    type: [Number, String],
    default: 0,
  },
    progressValue: {
        type: [Number,String],
        default: 0,
    },
},
  setup(__props) {

const store = useStore()
const keyboardConvert = new keyboardConverter()
const props = __props
// 进度回退时重建进度条，避免 n-progress 从 100% 过渡动画倒退回 0%
const progressBarKey = ref(0)
watch(
    () => Number(props.progressValue),
    (newVal, oldVal) => {
        if (oldVal !== undefined && newVal < oldVal) {
            progressBarKey.value++
        }
    }
)

const keyBoard = ref({
    reset:'',
    switchGuid:'',
    switchView:'',
    homing:'',
    enlarge:'',
    reduce:'',
    shoot:'',
})
function saveModel(){
    let sceneTypeId = null
    if(store.state.persistence.breadcrumb > 2){
        sceneTypeId = store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-2].id
    }else{
        sceneTypeId = store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-1].id
    }
    let param = {
        "userId": store.state.persistence.userInfo.userId,
        "tenantId": store.state.persistence.currentTenantId,
        "sceneTypeId": sceneTypeId,
        "resourceTypeId": store.state.persistence.currentResourceTypeId,
    }
    const {code, data, message} = saveUserTrainingSetting(param);
}

onBeforeMount(()=>{
    let {reset,switchGuid,switchView,homing,enlarge,reduce,shoot} = {...store.state.persistence.keyboard}

    // 安全转换为数字，处理空字符串和无效值
    const toNumber = (value: any): number | null => {
        if (value === null || value === undefined || value === '') return null
        const num = Number(value)
        return isNaN(num) ? null : num
    }
    keyBoard.value.reset = keyboardConvert.getKeyInfoByKeyCode(toNumber(reset))?keyboardConvert.getKeyInfoByKeyCode(toNumber(reset))[2]:''
    keyBoard.value.switchGuid = keyboardConvert.getKeyInfoByKeyCode(toNumber(switchGuid))?keyboardConvert.getKeyInfoByKeyCode(toNumber(switchGuid))[2] : ''
    keyBoard.value.switchView = keyboardConvert.getKeyInfoByKeyCode(toNumber(switchView))?keyboardConvert.getKeyInfoByKeyCode(toNumber(switchView))[2] : ''
    keyBoard.value.homing = keyboardConvert.getKeyInfoByKeyCode(toNumber(homing))?keyboardConvert.getKeyInfoByKeyCode(toNumber(homing))[2] : ''
    keyBoard.value.enlarge = keyboardConvert.getKeyInfoByKeyCode(toNumber(enlarge))?keyboardConvert.getKeyInfoByKeyCode(toNumber(enlarge))[2] : ''
    keyBoard.value.reduce = keyboardConvert.getKeyInfoByKeyCode(toNumber(reduce))?keyboardConvert.getKeyInfoByKeyCode(toNumber(reduce))[2] : ''
    keyBoard.value.shoot = keyboardConvert.getKeyInfoByKeyCode(toNumber(shoot))?keyboardConvert.getKeyInfoByKeyCode(toNumber(shoot))[2] : ''

    if(store.state.persistence.currentResourceTypeId){
        saveModel();
    }
    if(store.state.viewData.flyReplayData.enterPageMode == 2){
        store.commit('viewData/setFlyReplayData', {
            ...store.state.viewData.flyReplayData,
            enterPageMode: 1,
        })
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "backImage",
        src: __props.sceneImage,
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(__props.title), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(__props.description), 1)
          ]),
          (__props.pageType == '训练')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "title" }, "快捷键", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "key-lable" }, "重置", -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(keyBoard.value.reset), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "key-lable" }, "引导", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", null, _toDisplayString(keyBoard.value.switchGuid), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "key-lable" }, "视角", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", null, _toDisplayString(keyBoard.value.switchView), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "key-lable" }, "返回", -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", null, _toDisplayString(keyBoard.value.homing), 1)
                    ])
                  ])
                ]),
                (__props.sceneType == '输电')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "key-lable" }, "变焦", -1)),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("span", null, _toDisplayString(keyBoard.value.enlarge) + "/" + _toDisplayString(keyBoard.value.reduce), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "key-lable" }, "拍照", -1)),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("span", null, _toDisplayString(keyBoard.value.shoot), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _withDirectives(_createElementVNode("p", _hoisted_26, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "load-text" }, "正在加载资源", -1)),
          _createElementVNode("span", _hoisted_27, "（" + _toDisplayString(__props.receive) + "/" + _toDisplayString(__props.sum), 1),
          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "iconfont-line vk_xz_line" }, null, -1)),
          _createElementVNode("span", _hoisted_28, _toDisplayString(__props.speed) + "） " + _toDisplayString(__props.progressValue) + "%", 1),
          _withDirectives(_createElementVNode("span", { class: "file-text" }, _toDisplayString(__props.currentFile) + "/" + _toDisplayString(__props.maxFile), 513), [
            [_vShow, Number(__props.maxFile) > 0]
          ])
        ], 512), [
          [_vShow, __props.engineInitialized]
        ]),
        _withDirectives(_createElementVNode("p", _hoisted_29, "正在初始化引擎...", 512), [
          [_vShow, !__props.engineInitialized]
        ]),
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(), _createBlock(_unref(NProgress), {
            key: progressBarKey.value,
            type: "line",
            percentage: Number(__props.progressValue),
            "indicator-placement": "inside"
          }, null, 8, ["percentage"]))
        ])
      ])
    ])
  ]))
}
}

})